import { toast } from '@webapp/components/Notification'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useQueryFinancialAccount } from '../../models/useQueryFinancialAccount'

export const useGetFinancialAccountPresenter = () => {
  const intl = useProcurifyIntl()

  const { financialAccount, isFetching } = useQueryFinancialAccount({
    onError: () =>
      toast.error({
        title: intl.formatMessage(messages.fetchingFinancialAccountToastError),
      }),
  })

  return {
    data: {
      financialAccount,
    },
    states: {
      isFetching,
    },
  }
}
